import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { use100vh } from 'react-div-100vh';
import { AnimateSharedLayout } from 'framer-motion';
import { MAP_BRANCH } from 'constants/index';

import styles from './AuthPage.module.less';

const ARMY_BRANCH = MAP_BRANCH[2];

export default function AuthPage({ className, children, actions }) {
  const height = use100vh();
  const { pathname } = useLocation();
  const isFamily = pathname.includes('family');
  let src = isFamily ? `/images/branches/branchBg/BG-Signin-${ARMY_BRANCH}.webp` : '/images/signin-bg-2.webp';

  const homeLink = (
    <div className="home-link-container">
      <Link to="/" className="home-link" arial-label="Link to home page">
        <img src="/images/ccaoa-logo.png" alt="Logo" />
      </Link>
    </div>
  );

  return (
    <AnimateSharedLayout>
      <div className={classNames(styles.authPage, className, 'layout-page')} style={{ minHeight: height }} role="main">
        <div className={classNames('form-content', className)}>
          <div className="flex-grow"></div>

          <div className="form-area">
            {homeLink}
            {children}
            {typeof actions === 'function' ? actions(pathname) : actions}
          </div>

          <div className="flex-grow"></div>
        </div>

        <div className="background-container" style={{ height }}>
          <picture>
            <source srcSet={src} type="image/webp" />
            <img src={src} alt="Background" className="bg-image object-cover object-center h-screen" />
          </picture>
        </div>
      </div>
    </AnimateSharedLayout>
  );
}

AuthPage.propTypes = {
  actions: PropTypes.any,
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func,
};
AuthPage.defaultProps = {
  className: '',
};
